import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AreaList = Loadable(lazy(() => import("./AreaList")));
const AreaForm = Loadable(lazy(() => import("./AreaForm")));

const areaRoutes = [
  {
    path: "/Area/AreaList",
    element: <AreaList />,
  },
  {
    path: "/Area/AreaForm",
    element: <AreaForm />,
  },
  {
    path: "/Area/AreaForm/:areaId",
    element: <AreaForm />,
  },
];

export default areaRoutes;
